import sortable from "html5sortable/dist/html5sortable.es";
window.addEventListener("DOMContentLoaded", () => {
  const draggables = document.querySelectorAll(".js-sortable");
  if (draggables) {
    draggables.forEach((draggable) => {
      let options = {
        "forcePlaceholderSize": true
      };
      ["items", "acceptFrom", "handle", "placeholderClass", "placeholder", "hoverClass"].forEach((option) => {
        let dataOption = `draggable${option.charAt(0).toUpperCase() + option.slice(1)}`;
        if (draggable.dataset[dataOption]) {
          options[option] = draggable.dataset[dataOption];
        }
      });
      sortable(draggable, options);
    });
  }
});
